export const SUPPRESSED_ROUTES = [
    '/checkout',
    '/cart',
    '/pages/the-everyday-headphones',
    '/collections/throwback-exclusive',
    '/pages/spin-cable-choose-offer-checkout'
];

export const SUPPRESSED_KEYWORDS = [
    '5-in-1-magic-power-bank-exclusive-offer',
    'the-magic-power-bank-slim-adr4',
    'magic-power-bank-slim-exclusive-offer',
    'magic-power-bank-slim-exclusive-offer-checkout',
    'the-magic-power-bank-5-in-1-adr3'
];

export const SUPPRESSED_QUERY_PARAMS = [
    'utm_medium=influencer',
    'utm_medium=SMS',
    'utm_source=OneText'
];
